<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <RegisterUserDetail slot-scope="{data}"></RegisterUserDetail>
  </l-cache>
</template>
<script>
  import RegisterUserDetail from './registerUserDetail'
  export default {
    name: 'registerUserDetailBox',
    components: {RegisterUserDetail},
    methods: {
      async getItem (key) {
        return {}
      }
    }
  }
</script>

